
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IChartCriteria } from "@tylertech/tyler-api-types";

/**
 * ChartRegistryService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ChartRegistryService {
    private readonly $apiService = inject(ApiService);
    
    GetChartCriterias(): Promise<IChartCriteria[]> {
        return this.$apiService.sendAuth("IChartRegistryService/GetChartCriterias");
    }
    GetChartData(criteria: IChartCriteria): Promise<IChartCriteria> {
        return this.$apiService.sendAuth("IChartRegistryService/GetChartData", criteria);
    }
}
